module.exports = __webpack_public_path__ + "static/media/ic_company_info.83384534.svg";